'use client';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @primitive Toggle
 * ROLE: button | ARIA: aria-pressed (true/false)
 * KEYBOARD: Space/Enter toggles pressed state
 * FOCUS: single focus stop
 * LIVE-REGION: none (aria-pressed announced by AT)
 * PRM: background transition instant
 * FORCED-COLORS: pressed state border = Highlight
 * RTL: direction-agnostic
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/patterns/button/
 * SUBSTRATE: @radix-ui/react-toggle
 */
import * as RadixToggle from '@radix-ui/react-toggle';
import styles from './Toggle.module.css';
export function Toggle({ pressed, onPressedChange, disabled = false, children, className, ...rest }) {
    return (_jsx(RadixToggle.Root, { pressed: pressed, onPressedChange: onPressedChange, disabled: disabled, className: [styles.toggle, className].filter(Boolean).join(' '), ...rest, children: children }));
}
//# sourceMappingURL=Toggle.js.map